import React, { useRef, useEffect, useState } from "react";
import styled from "styled-components";
import InputField from "./InputField";
import { Colors } from "../../config";
import { airports } from "../../config/airports";

const BizAirportDrodown = ({
  data = [],
  value: code,
  onSelect,
  helperText,
  country,
  icon,
  label,
  name,
  required,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [search, setSearch] = useState("");
  const [value, setValue] = useState("");
  const [list, setList] = useState([]);

  useEffect(() => {
    if (code) {
      setValue(code);
      code?.label && setSearch(`${code?.value},${code?.label}`);
    } else {
      setValue("");
      setSearch("");
    }
  }, [data?.length, code]);

  const checkIfDefaultIsCountryAirports = (country) => {
    let countryAirports = airports.filter((ports) => ports.country === country);
    return countryAirports.length <= 0;
  };

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowOptions(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  useEffect(() => {
    setList(data);
  }, []);

  const handleShow = (e) => {
    e.preventDefault();
    setShowOptions(true);
    let newList = [...data];
    let filtered = [];
    if (search && value) {
      filtered = newList?.filter(
        (item) =>
          item?.label?.toUpperCase().includes(value?.label?.toUpperCase()) ||
          item?.value?.toUpperCase().includes(value?.value?.toUpperCase()) ||
          item?.country?.toUpperCase().includes(value?.country.toUpperCase()) ||
          item?.city?.toUpperCase().includes(value?.city?.toUpperCase()),
      );
    } else if (checkIfDefaultIsCountryAirports(country)) {
      filtered = [...newList];
    } else {
      filtered = newList?.filter((item) =>
        item?.country?.toUpperCase().includes(country?.toUpperCase()),
      );
    }
    setList(filtered);
  };

  const handleSearch = (e) => {
    let filtered;
    let newList = [...data];

    if (e.target.value) {
      filtered = newList?.filter(
        (item) =>
          item.label.toUpperCase().includes(e.target.value.toUpperCase()) ||
          item.value.toUpperCase().includes(e.target.value.toUpperCase()) ||
          item.city.toUpperCase().includes(e.target.value.toUpperCase()) ||
          item.country.toUpperCase().includes(e.target.value.toUpperCase()),
      );
    } else {
      if (checkIfDefaultIsCountryAirports(country)) {
        filtered = [...newList];
      } else {
        filtered = newList?.filter((item) =>
          item.country.toUpperCase().includes(country.toUpperCase()),
        );
      }
    }
    setList(filtered);
    setSearch(e.target.value);
  };

  const handleSelect = (item) => {
    // item?.label && setSearch(`${item?.value},${item?.label}`);
    onSelect({ target: { value: item.value, name } });
    code?.label && setSearch(`${code?.value},${code?.label}`);
    setShowOptions(false);
  };

  const handleBlur = () => {
    value?.label && setSearch(`${value?.value},${value?.label}`);
  };

  return (
    <BizAirportDrodownWrapper ref={wrapperRef}>
      <InputWrapper>
        <InputField
          label={label}
          value={search}
          disabled={data?.length <= 0}
          placeholder={`Search ${label}`}
          isRounded
          onFocus={(e) => handleShow(e)}
          onChange={handleSearch}
          leftImg={icon}
          onBlur={handleBlur}
          helperText={helperText}
          required={required}
        />
      </InputWrapper>
      {showOptions && list?.length > 0 && (
        <Options>
          <ListOptions>
            {list?.map((item) => (
              <SelectList onClick={() => handleSelect(item)}>
                <div>{`${item.city}, ${item.country}`}</div>
                <span>{`${item.label} (${item.value})`}</span>
              </SelectList>
            ))}
          </ListOptions>
        </Options>
      )}
    </BizAirportDrodownWrapper>
  );
};

const InputWrapper = styled.div``;
const TimeRange = styled.div``;
const ListOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0.5rem 0;
  height: auto;
  max-height: 150px;
  overflow-y: auto;
`;
const ListHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
`;
const SelectList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > span {
    font-size: 0.8rem;
    color: ${Colors.gray};
  }
`;
const ClassCard = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${(props) => (props.selected ? Colors.pomegranate : Colors.alto)};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: ${(props) =>
    props.selected ? Colors.pomegranateOpacity10 : "transparent"};
`;
const ClassWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;
const Options = styled.div`
  position: absolute;
  width: 90%;
  padding: 1rem;
  border-radius: 1rem;
  background: ${Colors.white};
  top: 4.5rem;
  border: 1px solid ${Colors.sharkApproxOpacity40};
  display: flex;
  flex-direction: column;
  z-index: 99;
`;
const BizAirportDrodownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default BizAirportDrodown;
